import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconApplicationSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M6 4C5.44772 4 5 4.44772 5 5C5 5.55228 5.44772 6 6 6H13C13.5523 6 14 5.55228 14 5C14 4.44772 13.5523 4 13 4H6ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H13C13.5523 9 14 8.55228 14 8C14 7.44772 13.5523 7 13 7H6ZM5 11C5 10.4477 5.44772 10 6 10H13C13.5523 10 14 10.4477 14 11C14 11.5523 13.5523 12 13 12H6C5.44772 12 5 11.5523 5 11ZM4 11C4 11.5523 3.55228 12 3 12C2.44772 12 2 11.5523 2 11C2 10.4477 2.44772 10 3 10C3.55228 10 4 10.4477 4 11ZM3 9C3.55228 9 4 8.55228 4 8C4 7.44772 3.55228 7 3 7C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9ZM4 5C4 5.55228 3.55228 6 3 6C2.44772 6 2 5.55228 2 5C2 4.44772 2.44772 4 3 4C3.55228 4 4 4.44772 4 5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
